/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface CustomerErrorDetailsDto {
    /**
     * 400: CUSTOMER_INITIAL_STATUS_NOT_ALLOWED (a customer is created with a status other than PROSPECT or ACTIVE by a person holding CUSTOMER_APPROVE), CUSTOMER_STATUS_CHANGE_NOT_ALLOWED (the edit would leave or enter PROSPECT or REJECTED; ACTIVE and INACTIVE switch freely), CUSTOMER_REJECTION_REASON_REQUIRED (blank rejection reason), CUSTOMER_REJECTION_REASON_TOO_LONG (rejection reason over 2000 characters). 403: CUSTOMER_APPROVE_REQUIRED (a customer is created with a status other than PROSPECT without CUSTOMER_APPROVE). The endpoint gates of approve/reject (CUSTOMER_APPROVE) and resubmit (CONTACT_EDIT or CONTACT_MANAGE_ALL) answer 403 without a code. 404: CUSTOMER_NOT_FOUND (the customer of a decision or of an edit does not exist). 409: CUSTOMER_NOT_PROSPECT (approving a customer that is neither PROSPECT nor REJECTED, or rejecting one that is not PROSPECT), CUSTOMER_NOT_REJECTED (resubmitting a customer that is not REJECTED), CUSTOMER_NOT_APPROVED (a customer that is not ACTIVE cannot become the customer of a process: process creation, also with an offer from its calendar entry query, and change of the process customer).
     */
    'code'?: CustomerErrorDetailsDtoCodeEnum;
}

export const CustomerErrorDetailsDtoCodeEnum = {
    CustomerInitialStatusNotAllowed: 'CUSTOMER_INITIAL_STATUS_NOT_ALLOWED',
    CustomerStatusChangeNotAllowed: 'CUSTOMER_STATUS_CHANGE_NOT_ALLOWED',
    CustomerRejectionReasonRequired: 'CUSTOMER_REJECTION_REASON_REQUIRED',
    CustomerRejectionReasonTooLong: 'CUSTOMER_REJECTION_REASON_TOO_LONG',
    CustomerApproveRequired: 'CUSTOMER_APPROVE_REQUIRED',
    CustomerNotFound: 'CUSTOMER_NOT_FOUND',
    CustomerNotProspect: 'CUSTOMER_NOT_PROSPECT',
    CustomerNotRejected: 'CUSTOMER_NOT_REJECTED',
    CustomerNotApproved: 'CUSTOMER_NOT_APPROVED',
} as const;

export type CustomerErrorDetailsDtoCodeEnum = typeof CustomerErrorDetailsDtoCodeEnum[keyof typeof CustomerErrorDetailsDtoCodeEnum];


